module.exports = __webpack_public_path__ + "static/media/07_tn.8d197234.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/07_tn.jpg
// module id = 221
// module chunks = 0